import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-503c7f98"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  align: "center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "d-inline-block text-truncate",
  style: {"max-width":"150px"}
}
const _hoisted_4 = {
  class: "d-inline-block text-truncate",
  style: {"max-width":"150px"}
}
const _hoisted_5 = { class: "flex ml-5" }

import { useI18n } from 'vue-i18n'
import { ref, onMounted, computed, Ref } from 'vue'
import { Message } from '@/types'

import router from '@/router'
import SeenUsers from './SeenUsers/SeenUsers.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageTable',
  props: {
    messages: {},
    isDoctor: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const messages = ref(props.messages)
const isDoctor = ref(props.isDoctor)
const loading = ref(false)
const { t } = useI18n()
const viewSeenList = ref(false)
const seenList = ref()
const itemsPerPage = ref(5)

const buildUsers = (seen: any) => {
  seenList.value = seen
  viewSeenList.value = true
}
const studentHeader = computed(() => {
  return [
    {
      title: 'Photo',

      key: 'photo',
      sortable: false,
      align: 'center',
    },
    {
      title: t('table.name'),

      key: 'name',
      sortable: false,
      align: 'center',
    },
  ]
})
const headers = computed(() => {
  let headers = [
    {
      title: 'Photo',

      key: 'photo',
      sortable: false,
      align: 'center',
    },
  ]

  if (!isDoctor.value) {
    headers.push({
      title: t('table.name'),

      key: 'name',
      sortable: false,
      align: 'center',
    })
  }
  headers.push(
    { title: t('title'), key: 'title', sortable: false, align: 'center' },
    {
      title: isDoctor.value ? t('table.created-at') : t('table.received-at'),
      key: 'createdAt',
      sortable: false,
      align: 'center',
    },

    {
      title: isDoctor.value ? t('table.update') : t('table.view'),
      key: 'action',
      sortable: false,
      align: 'center',
    }
  )

  if (isDoctor.value) {
    headers.push({
      title: t('seen-by'),
      key: 'seen',
      sortable: false,
      align: 'start',
    })
  }

  return headers
})

const applicantsArray = computed((): any => {
  const array: any[] = []

  messages.value.forEach((message) => {
    const seenUsers: any[] = []
    message.seenByUsers.forEach((user) => {
      const seenUser = {
        name: user.firstName + ' ' + user.lastName,
        photo: user.profileUrl,
      }
      seenUsers.push(seenUser)
    })
    const singleMessage = {
      id: message._id,
      photo: message.doctorProfile,
      title: message.title,
      content: message.content,
      createdAt: formatDate(message.createdAt),
      name: message.doctorTitle + ' ' + message.doctorLastName,
      doctorId: message.doctorId,
      seen: seenUsers,
    }
    array.push(singleMessage)
  })

  return array
})
const formatDate = (dateString: string) => {
  const [year, month, day] = dateString.split('-')
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const monthName = monthNames[parseInt(month, 10) - 1]
  return `${monthName} ${parseInt(day, 10)} ${year}`
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_data_table, {
      style: {"margin-top":"9px"},
      "items-per-page": itemsPerPage.value,
      "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((itemsPerPage).value = $event)),
      headers: headers.value,
      items: applicantsArray.value,
      loading: loading.value
    }, {
      [`item.photo`]: _withCtx((props) => [
        (props.item.photo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_v_img, _mergeProps({
                src: props.item.photo,
                alt: "student Image"
              }, props, {
                class: "image mb-2",
                referrerpolicy: "no-referrer",
                rel: "noreferrer",
                style: {"cursor":"pointer"},
                onClick: ($event: any) => (_unref(router).push(`/doctors/${props?.item?.doctorId}`))
              }), null, 16, ["src", "onClick"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_img, _mergeProps(props, {
                src: require('../../../assets/stud-team1.png'),
                alt: "student Image",
                class: "image mb-2",
                referrerpolicy: "no-referrer",
                rel: "noreferrer"
              }), null, 16, ["src"])
            ]))
      ]),
      [`item.name`]: _withCtx((props) => [
        _createElementVNode("p", _hoisted_3, _toDisplayString(props.item.name), 1)
      ]),
      [`item.title`]: _withCtx((props) => [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(props.item.title), 1)
      ]),
      [`item.action`]: _withCtx((props) => [
        (isDoctor.value)
          ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
              color: "#3fb984",
              onClick: ($event: any) => (_ctx.$emit('edit', props.item))
            }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('table.update')), 1)
              ]),
              _: 2
            }, 1040, ["onClick"]))
          : (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 1 }, props, {
              color: "#3fb984",
              onClick: ($event: any) => (_ctx.$emit('view', props.item))
            }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('table.view-message')), 1)
              ]),
              _: 2
            }, 1040, ["onClick"]))
      ]),
      [`item.seen`]: _withCtx((props) => [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.seen, (user, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (index == 0)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 0,
                    location: "bottom"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_avatar, _normalizeProps(_guardReactiveProps(props)), {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            alt: user.name,
                            src: user.photo
                          }, null, 8, ["alt", "src"])
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(user.name), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (props.item.seen.length > 1)
            ? (_openBlock(), _createBlock(_component_v_avatar, {
                key: 0,
                class: "ml-1",
                color: "#3fb984",
                onClick: ($event: any) => (buildUsers(props.item.seen)),
                style: {"cursor":"pointer"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" +" + _toDisplayString(props.item.seen.length - 1), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, 1032, ["items-per-page", "headers", "items", "loading"]),
    (viewSeenList.value)
      ? (_openBlock(), _createBlock(SeenUsers, {
          key: 0,
          viewSeenList: viewSeenList.value,
          usersList: seenList.value,
          studentHeader: studentHeader.value,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (viewSeenList.value = false))
        }, null, 8, ["viewSeenList", "usersList", "studentHeader"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})